import { jsx } from "react/jsx-runtime";
import { LinearProgress } from "@mui/material";
import { styled } from "@mui/system";
import isFunction from "lodash/isFunction";
import { useEffect, useState } from "react";
import Box from "../Box";
const PROGRESS_BAR_TOKENS = {
  height: "4px",
  color: {
    default: "infoContent",
    warning: "warningContent",
    error: "errorContent",
    success: "successContent"
  }
};
const StyledLinearProgress = styled(LinearProgress)(({ theme, status }) => {
  const palette = theme.palette;
  return {
    height: PROGRESS_BAR_TOKENS.height,
    backgroundColor: palette.elevation2.main,
    width: "100%",
    "& .MuiLinearProgress-bar": {
      backgroundColor: palette.elevation2[PROGRESS_BAR_TOKENS.color[status]]
    }
  };
});
const FullWidthBox = styled(Box)({
  width: "100%"
});
const STEP = 100;
const ProgressBar = ({ autoHideDuration = 3e3, status, isPause = false, onComplete, className }) => {
  const [progress, setProgress] = useState(100);
  useEffect(() => {
    if (autoHideDuration > 0) {
      const updateTime = STEP;
      const decrement = STEP / (autoHideDuration / updateTime);
      const interval = setInterval(() => {
        if (isPause) {
          return;
        }
        setProgress((prev) => {
          const newProgress = prev - decrement;
          if (newProgress <= 0) {
            clearInterval(interval);
            if (isFunction(onComplete)) {
              onComplete();
            }
          }
          return Math.max(newProgress, 0);
        });
      }, updateTime);
      return () => clearInterval(interval);
    }
  }, [autoHideDuration, onComplete, isPause]);
  return /* @__PURE__ */ jsx(FullWidthBox, { className, children: /* @__PURE__ */ jsx(
    StyledLinearProgress,
    {
      variant: "determinate",
      value: progress,
      status
    }
  ) });
};
var ProgressBar_default = ProgressBar;
export {
  ProgressBar_default as default
};
